var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4824_79730)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EB6F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 24V21.3333C5.33398 18.3878 7.7218 16 10.6673 16H14.6673C15.4037 16 16.0007 15.403 16.0007 14.6667V14.6667C16.0007 13.9303 15.4037 13.3333 14.6673 13.3333H9.33399C7.12485 13.3333 5.33398 11.5425 5.33398 9.33333V9.33333C5.33398 7.12419 7.12484 5.33333 9.33398 5.33333H13.334C14.8067 5.33333 16.0007 4.13943 16.0007 2.66667V2.66667V0",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 24V21.3333V21.3333C7.99935 19.8606 9.19326 18.6667 10.666 18.6667H14.666C16.8752 18.6667 18.666 16.8758 18.666 14.6667V14.6667C18.666 12.4575 16.8752 10.6667 14.666 10.6667H9.33268C8.5963 10.6667 7.99935 10.0697 7.99935 9.33333V9.33333C7.99935 8.59695 8.5963 8 9.33268 8H13.3327C16.2782 8 18.666 5.61218 18.666 2.66666V-7.15256e-07",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4824_79730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChat);
export default __webpack_public_path__ + "static/media/logo-chat.e9adb39e96ecf7836cba68bf9bbd44f7.svg";
export { ForwardRef as ReactComponent };